import React, { useEffect, useState } from "react";
import { applyTheme, getStoredTheme, toggleTheme } from "../../utils/helpers/theme";

const ThemeToggle = ({ className = "dropdown-item", showLabel = true }) => {
  const [theme, setTheme] = useState(getStoredTheme());

  useEffect(() => {
    setTheme(applyTheme(getStoredTheme()));
  }, []);

  const handleToggle = () => {
    setTheme(toggleTheme());
  };

  const isDark = theme === "dark";

  return (
    <button
      type="button"
      className={className}
      onClick={handleToggle}
      aria-label={isDark ? "Gunakan mode terang" : "Gunakan mode gelap"}
      aria-pressed={isDark}
      title={isDark ? "Gunakan mode terang" : "Gunakan mode gelap"}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="icon icon-1">
        {isDark ? (
          <>
            <path d="M12 12m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0" />
            <path d="M3 12h1m8 -9v1m8 8h1m-9 8v1m-6.4 -15.4l.7 .7m12.1 -.7l-.7 .7m0 11.4l.7 .7m-12.1 -.7l-.7 .7" />
          </>
        ) : (
          <path d="M12 3c.132 0 .263 0 .393 0a7.5 7.5 0 0 0 7.92 12.446a9 9 0 1 1 -8.313 -12.454z" />
        )}
      </svg>
      {showLabel ? (isDark ? "Light Mode" : "Dark Mode") : null}
    </button>
  );
};

export default ThemeToggle;
